import { FieldDictionary } from './../field-dictionary.model';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { FinraException } from '../finra-exception.model';
import { FinraExceptionService } from '../finra-exception.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import {default as AggoOrderColumnsJSON} from 'app/Shared/Constant/Grid Column Names/AGGO-Columns.json';
import {default as TDETColumnsJSON} from 'app/Shared/Constant/Grid Column Names/TDET-Columns.json';
import {default as LegDetailsColumnsJSON} from 'app/Shared/Constant/Grid Column Names/LegDetails-Columns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService,MessageService } from 'primeng/api';
import { Util } from 'app/Shared/Constant/Util';
import { DataService } from 'app/Shared/Services/data.service';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { EventConversionComponent } from 'app/Shared/Component/event-conversion/event-conversion.componenet';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-finra-exception-edit',
    imports: [CommonModule, DialogModule, MatStepperModule, Select, MatDividerModule, EventConversionComponent,
        ButtonModule, TableModule, LowerCasePipe, FormsModule, NgClass, MultiSelectModule, MatTooltipModule, MatCheckboxModule, DatePickerModule, ToggleSwitchModule],
    templateUrl: './finra-exception-edit.component.html',
    styleUrls: ['./finra-exception-edit.component.scss']
})
export class FinraExceptionEditComponent implements OnInit {
  @Input() finraException!: FinraException;
  @Input() fieldDictionaryList!: FieldDictionary[];
  @Input() finraExceptionType!: string;
  @Input() isMultiEdit!: boolean;
  @Input() firmROEIDList!: Array<string>
  @Input() correctCodeLength!: number;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(('eventConvert')) eventConvert!: EventConversionComponent;

  originalJSON : any;
  loadingView!: boolean;
  timeInForceChoice!: string;
  timeInForceValue!: string | null;
  isClickedOnce!: boolean;
  columnJson: any = [];
  aggoOrdersCols: any;
  aggoOrdersData: any;
  handlingInstructionCols: any;
  handlingInstructionData: any
  tdetCols: any;
  legDetailsCols:any;
  tradeSideDetailsData: any;
  getData: any = '';
  handlingInstructionValue: Array<any> = [];
  booleanDropDown:any;
  givenNameForFDID = '';
  checked: boolean=false;
  fdidChecked: boolean=false;
  clearValueJSON:Array<any>=[];
  selectedTabIndex: number = 0;
  isShowConvertEventStepper: boolean = false;
  convertLable: string = "";


  constructor(public finraExceptionService: FinraExceptionService,
    public userService: UserService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private gridService: GridService,
    public dataService:DataService ) {
    this.aggoOrdersCols = AggoOrderColumnsJSON;
    this.aggoOrdersData = [];
    this.tdetCols = TDETColumnsJSON;
    this.handlingInstructionCols = this.userService.handlingInstructionsJSON;
    this.legDetailsCols = LegDetailsColumnsJSON;
    this.tradeSideDetailsData = [];    
  }

  ngOnInit() {
    if(this.constantService.CONVERT_EVENT_JSON[this.finraException.type] != undefined) {
      this.convertLable = "Convert to " + 
      this.constantService.CONVERT_EVENT_JSON[this.finraException.type];
    }
    
    this.originalJSON = this.finraException.originalJSON;
    this.loadingView = false;
    this.booleanDropDown = this.constantService.BOOLEAN_DROPDOWN;
    this.fieldDictionaryList.forEach(element => {
      if (this.isMultiEdit) {
        this.isShowConvertEventStepper = false;
       if (element.fieldName === 'timeInForce') {
            const parsedJson = (element.jsonValue);
            this.timeInForceChoice = Object.keys(parsedJson)[0];
            this.timeInForceValue = null;
        } else if (element.fieldName === 'handlingInstructions') {
          this.handlingInstructionData = [{}];
          this.handlingInstructionCols = [];
          element.jsonValue = null;
        } else if (element.fieldName === 'type' || element.fieldName === 'CATReporterIMID') {
          element.jsonValue = element.jsonValue;
        } else if (element.fieldName.toLowerCase() === 'selldetails' || element.fieldName.toLowerCase() === 'buydetails' ||
          element.fieldName.toLowerCase() === 'clientdetails' ||
          element.fieldName.toLowerCase() === 'firmdetails' ||
          element.fieldName.toLowerCase() === 'legdetails' ||
          element.fieldName.toLowerCase() === 'aggregatedorders') {
          element.jsonValue = [{}];
        } else {
          element.jsonValue = null;
        }
      } else {
        if (element.fieldName === 'fileID') {
          this.finraException['fileID'] = element.jsonValue;
        }
        if (element.fieldName === 'type' && this.constantService.CONVERT_EVENT_JSON[this.finraException.type] != undefined) {
          this.isShowConvertEventStepper = true;
        } else if (element.fieldName === 'type' && this.constantService.CONVERT_EVENT_JSON[this.finraException.type] == undefined) {
          this.isShowConvertEventStepper = false;
        }
      if (element.fieldName.toLowerCase() === 'timeinforce') {
        if (element.jsonValue !== undefined &&
          element.jsonValue !== null) {
          const parsedJson = (element.jsonValue);
          this.timeInForceChoice = Object.keys(parsedJson)[0];
          this.timeInForceValue = parsedJson[Object.keys(parsedJson)[0]];
        }else{
          this.timeInForceChoice = element.choiceDetails[0].value;
        } 
      } else if(element.fieldName.toLowerCase() === 'selldetails' || element.fieldName.toLowerCase() === 'buydetails' ||
        element.fieldName.toLowerCase() === 'clientdetails' ||
        element.fieldName.toLowerCase() === 'firmdetails'|| 
        element.fieldName.toLowerCase() === 'legdetails' || 
        element.fieldName.toLowerCase() === 'aggregatedorders') {
        element.jsonValue = element.jsonValue != null && element.jsonValue != undefined ? (element.jsonValue):[{}];
      } else if(element.fieldName.toLowerCase() === 'handlinginstructions') {
        let obj:any = {};
        obj = (element.jsonValue);
        let result = Util.isDefinedAndNotNull(obj) ? Object.keys(obj).map(function (key) {
          return [(key), obj[key]];
        }): [];
        this.handlingInstructionData = Util.isDefinedAndNotNull( element.jsonValue) ? [(element.jsonValue)] : [{}];
        this.handlingInstructionCols = this.gridService.getGridColumnsHasValues(result);
        element.jsonValue = null;
      }
     }
      /* Filter Side Field Choice Values for ME* & MO* Event Types */
        if(element.fieldName.toLowerCase() === 'side') {
          if(this.finraException.type.toLocaleLowerCase().startsWith("me")) {
            element.choiceDetails = element.choiceDetails.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
          } else if (this.finraException.type.toLocaleLowerCase().startsWith("mo")) {
            element.choiceDetails = element.choiceDetails.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
          }
        }
      /* End of Filter Side Field Choice Values for ME* & MO* Event Types */
    });
    this.getAggoOrdersColumns();
    this.getLegDetailsColumns();
    this.getTDETColumns();
  }
  getValue(json: any) {
    let obj:Array<any> = [] 
    obj = JSON.parse(json);
    let result = obj!== undefined? Object.keys(obj).map(function (key: any) {
     return [(key), obj[key]];
    }): [];
  }

  getAggoOrdersColumns() {
    let column: any = this.aggoOrdersCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.aggoOrdersCols = this.gridService.getGridColumns(column);
    }
  }

  getTDETColumns() {
    let column: any = this.tdetCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.tdetCols = this.gridService.getGridColumns(column);
    }
  }

  getLegDetailsColumns() {
    let column: any = this.legDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.legDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  onSave() {
    this.isClickedOnce = true;
    this.givenNameForFDID = '';
    this.checked = false;

    /* Form necessary Field Validation */
      if(!this.validateEssentialFormFields()) {
        return false;
      }
    /* End of Form necessary Field Validation */

    let updatedJSONobject: any = {};
    this.fieldDictionaryList.forEach((element, index) => {
      if (element.jsonValue !== null && element.jsonValue !== "") {
        if((element.fieldName.toLowerCase() === 'selldetails' || 
        element.fieldName.toLowerCase() === 'buydetails' ||
        element.fieldName.toLowerCase() === 'clientdetails' ||
        element.fieldName.toLowerCase() === 'firmdetails' ||
        element.fieldName.toLowerCase() === 'legdetails')) {
          updatedJSONobject[element.fieldName] = this.fieldDictionaryList[index].jsonValue[0] && Object.keys(this.dataService.removeNullValueObj(this.fieldDictionaryList[index].jsonValue[0])).length === 0 ? null : this.fieldDictionaryList[index].jsonValue;
      } else if (element.fieldName.toLowerCase() === 'aggregatedorders') {
        if (this.fieldDictionaryList[index].jsonValue != null
          && this.fieldDictionaryList[index].jsonValue != undefined) {
            updatedJSONobject[element.fieldName] = this.fieldDictionaryList[index].jsonValue[0] && Object.keys(this.dataService.removeNullValueObj(this.fieldDictionaryList[index].jsonValue[0])).length === 0 ? null :this.fieldDictionaryList[index].jsonValue;
          }
      }  else if(element.fieldName.toLowerCase() === 'timeinforce') {
        this.timeInForceChoice = this.timeInForceChoice === '' ? element.choiceDetails[0].value : this.timeInForceChoice;
        updatedJSONobject[element.fieldName] =  this.timeInForceValue != undefined ? {[this.timeInForceChoice]: (['GTT'].indexOf(this.timeInForceChoice) >= 0 ? this.timeInForceValue : JSON.parse(this.timeInForceValue))} : null;
      }  else if(element.javaDataType.toLowerCase() === 'unsigned' 
              || element.javaDataType.toLowerCase() === 'number' 
              || element.javaDataType.toLowerCase() === 'int' ) {
        let numValue: number = Number(this.fieldDictionaryList[index].jsonValue);
        updatedJSONobject[element.fieldName] = numValue;
      } else if( element.fieldName.toLowerCase() == 'firmdesignatedid'
       && this.fieldDictionaryList[index].jsonValue != null 
       &&  this.fieldDictionaryList[index].jsonValue != undefined){
        updatedJSONobject[element.fieldName] = this.fieldDictionaryList[index].jsonValue.toString().trim().length == 0 ? null : this.fieldDictionaryList[index].jsonValue.toString().trim();
      } else {
       updatedJSONobject[element.fieldName] = this.fieldDictionaryList[index].jsonValue;
      }
      } else if(element.fieldName.toLowerCase() === "handlinginstructions" && this.handlingInstructionData) {
        let handlingArr: any = [];
        let handlingObj: any;
        this.handlingInstructionCols.forEach((element: { header: string; }) => {
          let keys = Object.keys(this.handlingInstructionData[0]);
          if (this.handlingInstructionData[0] && Object.keys(this.handlingInstructionData[0]).length > 0 && keys.indexOf(element.header) >= 0) {
            //handlingArr.push({ [element.header]: this.handlingInstructionData[0][element.header] })
            handlingArr.push(this.userService.getHandlingInstructionValueFinra(element,this.fieldDictionaryList[index], this.handlingInstructionData[0]));
          }
        });
        if(handlingArr != undefined && handlingArr.length>0){
          handlingObj = Object.assign.apply(Object, handlingArr); // Array of obj into one obj
        }
        updatedJSONobject[element.fieldName] = this.handlingInstructionCols.length > 0 && handlingObj !== undefined ? this.constantService.removeNullValueObj(handlingObj) : null;
        updatedJSONobject[element.fieldName] = updatedJSONobject[element.fieldName] !== null && Object.keys(updatedJSONobject[element.fieldName]).length === 0 ? null :
          updatedJSONobject[element.fieldName];
      }
      if (updatedJSONobject[element.fieldName] === null) {
        delete updatedJSONobject[element.fieldName];
      }
     
    });
    
    if(this.isMultiEdit) {
      this.multiEditSave(updatedJSONobject,this.finraException.reportDate);    
    } else {
      this.finraExceptionService.saveFinraExceptions(
        this.finraException.id,
        this.finraException.firmROEID,
        this.finraException.reportDate,
        JSON.stringify(updatedJSONobject),
      ).subscribe({
          next: (response:any) => {
            if(response["status"]){
              this.messageService.add({ severity: 'success', summary: 'Update', detail: 'Record Updated Successfully!' });
            }else{
              this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
            }
          this.closeDialog.emit(true);
          this.finraExceptionService.showEdit = false;
          this.isClickedOnce = false;
          this.handlingInstructionData = [];
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
          this.isClickedOnce = false;
        }
      });
    }
    return true;
  }

  validateEssentialFormFields() {
    let updatedJSONObject: any = {};

    this.fieldDictionaryList.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        updatedJSONObject[element.fieldName] = (this.fieldDictionaryList[index].jsonValue);
      }
    });

    /* Validation for Total Multileg Details */
      if(updatedJSONObject.hasOwnProperty('numberOfLegs') && (updatedJSONObject.numberOfLegs!==null && updatedJSONObject.numberOfLegs!==undefined && updatedJSONObject.numberOfLegs!=='' && updatedJSONObject.numberOfLegs!==0) && updatedJSONObject.hasOwnProperty('legDetails') && (updatedJSONObject.numberOfLegs !== updatedJSONObject.legDetails.length)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter matching info for Leg Details and NumberOfLegs' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('numberOfLegs') && updatedJSONObject.numberOfLegs > 0 && updatedJSONObject.hasOwnProperty('legDetails') && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.legDetails)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Leg Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for Total Multileg Details */

    /* Validation for AggoOrder Details */
      if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 0 && Object.keys(this.dataService.removeNullValueObj(updatedJSONObject.aggregatedOrders[0])).length > 0 && updatedJSONObject.hasOwnProperty('representativeInd') && (updatedJSONObject.representativeInd===null || updatedJSONObject.representativeInd===undefined || updatedJSONObject.representativeInd==='')) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter RepresentativeInd relevant with Aggo Details' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 1 && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.aggregatedOrders)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Aggo Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for AggoOrder Details */

    return true;
  }

  multiEditSave(updatedJSONobject: any,reportDate: any) {
    if(this.clearValueJSON.length >= 1) {
      this.clearValueJSON.forEach((element)=> {
        updatedJSONobject[element.fieldName] = "";
      });
      /* Remove Blank TimeInForce Value from Updated JSON Object */
      if(updatedJSONobject.timeInForce === undefined  || updatedJSONobject.timeInForce === "" || updatedJSONobject.timeInForce === null) {
        delete updatedJSONobject.timeInForce;
      }
    }
    let msg = '';
      msg = 'Do you want to save changes for '+ this.correctCodeLength +' records?';
    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.finraExceptionService.saveFinraExceptionsMultipleRecords(
        this.firmROEIDList,
        (updatedJSONobject),
        (this.originalJSON),
        reportDate
      ).subscribe({
        next: (response:any) => {
          this.closeDialog.emit(true);
          this.finraExceptionService.showEdit = false;
          this.isClickedOnce = false;
          this.handlingInstructionData = [];
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
          this.isClickedOnce = false;
        }
      });
      }
    });
  }
  clearValue(row: FieldDictionary) {
    row.isMultiEdited = true;
    this.clearValueJSON.push(row)
     this.clearValueJSON =  this.clearValueJSON.filter((n, i) =>  this.clearValueJSON.indexOf(n) === i);
  }

  removeNullValueObj(obj: { [x: string]: any; }) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === "" || obj[key] === null) {
        delete obj[key]
      }
    })
    return obj
  }

  getFDID(index: number) { 
    this.finraExceptionService.getFDID(this.givenNameForFDID)
    .subscribe({
      next: (data:any) => {
      this.fieldDictionaryList[index].jsonValue = data.Data.length > 0? data.Data[0].generatedFDID: null;
      if(this.fieldDictionaryList[index].jsonValue === null) {
        this.messageService.add({ severity: 'error', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
      } else {
        this.messageService.add({ severity: 'success', summary: 'record Found', detail: 'Updated Firm Designated ID' });
      }
    }});
  }
  getDateTimeTFormate(keyName:any, event:any, index:any){
    try {
      const datetime = event.target.value;
      this.fieldDictionaryList[index].jsonValue = this.userService.getDateTimeTFormate(datetime, keyName);
      if (this.userService.timeStampErrorField === keyName) {
        this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.fieldDictionaryList[index].jsonValue });
      }else{
      if (this.userService.timeStampErrorField === keyName || !this.userService.timeStampErrorField) {
        this.userService.timeStampErrorField = ''; 
      }
    }
    } catch (e) {
      this.userService.timeStampErrorField = keyName;
      this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.fieldDictionaryList[index].jsonValue });
    }
  }

  setEditRowValue(index: number, key: string) {
    /* Receiving updated TimeInForce Value */
      let timeInForceValue = this.userService.getTimeInforceValue(key, this.fieldDictionaryList[index].fieldName, true, this.fieldDictionaryList);
      this.timeInForceChoice = key;
      this.timeInForceValue = timeInForceValue;
    /* End of Receiving updated TimeInForce Value */

    this.fieldDictionaryList[index].jsonValue = {
      [key]: timeInForceValue,
    }

  }
  selectionChange(event: any) {
    this.selectedTabIndex = event.selectedIndex;
    this.isClickedOnce = false;
  }
  onClose() {
    this.finraExceptionService.showEdit = false;
  }
  getChildColumns(fieldName:any){
    if(["legDetails"].includes(fieldName)){
      /* Provide Drop Down Field Values to respective Fields (Side/OpenCloseIndicator) */
        if(this.legDetailsCols.length > 0) {
          for(let i=0; i < this.legDetailsCols.length; i++) {
            let Field_Dictionary_Object;
            if(this.legDetailsCols[i]["dropdown"].toLowerCase()==="yes") {
              Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.legDetailsCols[i]["field"]);
              this.legDetailsCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
            }
          }
        }

      return this.legDetailsCols;
    } else if (["clientDetails", "firmDetails", "buyDetails", "sellDetails"].includes(fieldName)) {
        /* Provide Drop Down Field Values to respective Fields (Side) */
        if(this.tdetCols.length > 0) {
          for(let i=0; i < this.tdetCols.length; i++) {
            let Field_Dictionary_Object;
            if(this.tdetCols[i]["dropdown"].toLowerCase()==="yes") {
              Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.tdetCols[i]["field"]);
              this.tdetCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
              if(this.tdetCols[i]["field"].toLowerCase()==="side") {
                if(this.finraException.type.toLocaleLowerCase().startsWith("me")) {
                  this.tdetCols[i]["dropdownvalue"] = this.tdetCols[i]["dropdownvalue"].filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
                } else if (this.finraException.type.toLocaleLowerCase().startsWith("mo")) {
                  this.tdetCols[i]["dropdownvalue"] = this.tdetCols[i]["dropdownvalue"].filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
                }
              }
            }
          }
        }
      }
   return this.tdetCols;
 }

/* Get Dropdown Values for LegDetails/BuyDetails/SellDetails/FirmDetails/ClientDetails etc. Dropdown Fields */
  getCATDetailsFieldDropdownValues(editRow: any, col: any, tradeSideRowData: any) {
    let fieldOptions = col.dropdownvalue;
      if(["legDetails"].includes(editRow.fieldName)) {
        if(["side"].includes(col.field)) {
          if(tradeSideRowData.symbol && tradeSideRowData.symbol !== null && tradeSideRowData.symbol.length > 0 && (!tradeSideRowData.optionID || tradeSideRowData.optionID === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
          } else if(tradeSideRowData.optionID && tradeSideRowData.optionID !== null && tradeSideRowData.optionID.length > 0 && (!tradeSideRowData.symbol || tradeSideRowData.symbol === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
          }
        }if(["accountHolderType"].includes(col.field)) {
          fieldOptions = col.dropdownvalue.filter((rowObj: any) => rowObj.value);
        }
      }
    return fieldOptions;
  }

 nextStepper(stepper: MatStepper){
  stepper.next();  
 }

 previousStepper(stepper: MatStepper){
  stepper.previous();
 }
 getOrderKeyDateFormate(keyName:any, event:any, index:any){
  let key = index != undefined ? `${keyName}_${index}` : keyName;
    try {
      const datetime = event.target.value;
      this.fieldDictionaryList[index].jsonValue = this.userService.getDateTimeTFormate(datetime, key);
      if (this.userService.timeStampErrorField == key) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Order Key Date', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(key)});
      }
    } catch (e) {
      this.userService.timeStampErrorField = key;
      this.messageService.add({ severity: 'error', summary: 'Invalid Order Key Date', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(key) });
    }
  }
  clearErrorFieldValue(){
  this.userService.timeStampErrorField = '';   
  }

}